import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './list';
import Location from './location';

export default () => (
  <Switch>
    <Route path="/locations/:id" component={Location} />
    <Route component={List} />
  </Switch>
);
